import Condition from "./Condition";

class Rule {
    name: string;
    event: { type: string | null };
    conditions: Condition;

    constructor() {
        this.name = "";
        this.event = { "type": null };
        this.conditions = new Condition();
    }
}

export default Rule;